<template>
    <div>
        <div class="carousel-box">
            <div class="title">轮播图片维护</div>
            <div :style="{height: carouselHeight + 'px'}" ref="indexCarouselBox" class="indexCarouselBox">
                <Carousel v-if="carouselList.length>0" :height="carouselHeight" :width="carouselWidth + 'px'" loop>
                    <Carousel-item v-for="(item,index) in carouselList" :key="item.table_id">
                        <i class="ivu-icon ivu-icon-md-close" @click="delCarousalImg(item,index)"></i>
                        <div><img class="carouselImg" :style="{height: carouselHeight + 'px'}" :src="item.img_url ? baseUrl + item.img_url : '' " /></div>
                    </Carousel-item>
                </Carousel>
                <div class="no-img" v-else>暂无图片</div>
            </div>            
        </div>
        <div class="footer-btn">
            <Row type="flex" justify="center">
                <Col :xs="12" :sm="12" :md="8" :lg="6" :xl="3">
                    <Button type="primary" style="width:9em;" @click="saveCarousel">轮播图片保存</Button>
                </Col>
                <Col :xs="12" :sm="12" :md="8" :lg="6" :xl="3">
                    <Upload :action="action" :show-upload-list="false" :on-success="uploadCarousalSuccess">
                        <Button icon="ios-cloud-upload-outline" style="width:9em;margin-left:15px">图片上传</Button>
                    </Upload>
                </Col>
            </Row>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            carouselHeight: 377,
            carouselWidth: '',
            baseUrl: '/api/staticSiteImg/',
            action: '/api/homepage/uploadImage',
            carouselList: [],
            carouselInsertList: [], // 新添加的列表
            carouselDelList: [], // 要删除的列表
        }
    },
    mounted() {
        window.onresize = () => {
            this.carouselHeight = document.documentElement.clientHeight/3.123
            this.carouselWidth = this.$refs.indexCarouselBox.carouselWidth
        }
        this.$nextTick(() => {
            this.carouselHeight = document.documentElement.clientHeight/3.123
        })
    },
    beforeDestroy() {
        window.onresize = null
    },
    created(){
        this.getCarouselList()
    },
    methods: {
        //请求轮播图片
        getCarouselList(){ 
            axios.post('/homepage/get', {}).then(res => {  
                if (res != null && res.length > 0) {
                    this.carouselList = JSON.parse(JSON.stringify(res))
                }
            })
        },
        // 轮播图上传成功
        uploadCarousalSuccess(response, file, fileList) {
            this.carouselList.push({
                img_url: response.data
            })
            this.carouselInsertList.push({
                img_url: response.data
            })
        },
        // 删除轮播图
        delCarousalImg(item,index){
            this.$Modal.confirm({
                title: this.$notice('deletePicture'),
                content: '',
                onOk: () => {
                    this.carouselList.splice(index,1)
                    this.carouselDelList.push({
                        table_id: item.table_id,
                    })
                }
            });
        },
        // 保存轮播图
        saveCarousel(){
            this.$Modal.confirm({
                title: this.$notice('sureSave'),
                content: '',
                onOk: () => {
                    if (this.carouselInsertList.length > 0) {
                        axios.post('/homepage/insert', this.carouselInsertList).then(res => { 
                            this.$Message.info(this.$t('Save_Successful'))
                            this.getCarouselList()
                        })
                    }
                    if (this.carouselDelList.length > 0) {
                        axios.post('/homepage/delete', this.carouselDelList).then(res => { 
                            this.$Message.info(this.$t('Save_Successful'))
                            this.getCarouselList()
                        })
                    }
                }
            });
        }, 
    }
}
</script>

<style lang="scss" scoped>
.footer-btn{
    border-top: none !important;
    margin-top: 30px;
}
>>> .ivu-carousel-item{
    position: relative !important;
    .carouselImg{
        width: 100%;
        margin: 0 auto;
    }
    i{
        position: absolute;
        right: 2px !important;
        top: 0px;
        color: red;
        cursor: pointer;
        font-size: 16px;
        z-index: 9999;
        &:hover{
            background: rgba(27,21,21,.45);
            border-radius: 16px;
        }
    }
}
.carousel-box{
    width: calc(100% - 416px);
    margin: 0 auto;
    .title{
        font-size: 18px;
        margin-bottom: 15px;
    } 
    .imgTip{
        color: red;
    }
    .no-img{
        width: 100%;
        height: 100%;
        text-align: center;
        transform: translateY(40%);
        color: #515a6e;
    }
}

@media screen and (max-width:1024px) {
    .carousel-box{
        width: 100% !important;
        height: auto !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/MainImageSave.vue